import { lazy } from 'react';

import { paths } from '../paths';

const NotFoundPage = lazy(() => import('src/modules/error/not-found/not-found'));
const ForbiddenPage = lazy(() => import('src/modules/error/forbidden/forbidden'));
const InternalErrorPage = lazy(() => import('src/modules/error/internal-error/internal-error'));

export const errorRoutes = [
  {
    path: paths.error.forbidden,
    element: (
      <ForbiddenPage />
    )
  },
  {
    path: paths.error.notFound,
    element: (
      <NotFoundPage />
    )
  },
  {
    path: paths.error.serverError,
    element: (
      <InternalErrorPage />
    )
  }
];
